import { memo } from "react";

import dayjs from "@/lib/dayjs";

const FORMAT_TEMPLATE = "YYYY年MM月DD日 HH時mm分";

type Props = {
	publishedAt?: string | null;
	updatedAt?: string | null;
};

export const ArticleDate = memo(({ publishedAt, updatedAt }: Props) => {
	const formattedPublishedAt = publishedAt ? dayjs(publishedAt).format(FORMAT_TEMPLATE) : null;
	const formattedUpdatedAt = updatedAt ? dayjs(updatedAt).format(FORMAT_TEMPLATE) : null;

	return (
		<div className="text-right text-sm text-zinc-500">
			{!!formattedPublishedAt && <p>公開日：{formattedPublishedAt}</p>}
			{!!formattedUpdatedAt && <p>最終更新日：{formattedUpdatedAt}</p>}
		</div>
	);
});
